import { useMemo } from 'react';
import '@aws-amplify/ui-react/styles.css';
import '@aws-amplify/ui-react-storage/styles.css';
import { useAuthenticator, withAuthenticator } from '@aws-amplify/ui-react';
import { getUrl } from 'aws-amplify/storage';
import {
  createAmplifyAuthAdapter,
  createStorageBrowser,
  defaultHandlers,
} from '@aws-amplify/ui-react-storage/browser';

function App() {
  const { signOut } = useAuthenticator();

  const StorageBrowser = useMemo(() => {
    const adapter = createAmplifyAuthAdapter();
    const { StorageBrowser: StorageBrowserComponent } = createStorageBrowser({
      config: {
        ...adapter,
        listLocations: async () => ({
          items: [
            {
              id: 'check-extraction-input',
              bucket: 'prd-daitech-ai-processing',
              prefix: 'check-extraction/input/',
              permissions: ['list', 'write'],
              type: 'PREFIX',
            },
            {
              id: 'check-extraction-output',
              bucket: 'prd-daitech-ai-processing',
              prefix: 'check-extraction/output/',
              permissions: ['list', 'get'],
              type: 'PREFIX',
            },
            {
              id: 'loan-processing-incoming-pdf-files',
              bucket: 'prod-ppay-lmstech-loan-processing',
              prefix: 'incoming-pdf-files/',
              permissions: ['list', 'get', 'write', 'delete'],
              type: 'PREFIX',
            },
            {
              id: 'loan-processing-incoming-pdf-files',
              bucket: 'prod-ppay-daitech-loan-docs',
              prefix: 'loan-documents/',
              permissions: ['list', 'get'],
              type: 'PREFIX',
            },

            

          ],
          nextToken: undefined,
        }),
      },
      actions: {
        default: {
          download: (input) => {
            if (input.all.length !== 1) {
              return defaultHandlers.download(input);
            }

            const { key } = input.data;
            const filename = key.split('/').pop() || 'download';

            return {
              result: getUrl({
                path: key,
                options: {
                  bucket: {
                    bucketName: input.config.bucket,
                    region: input.config.region,
                  },
                  validateObjectExistence: true,
                  contentDisposition: 'attachment',
                },
              })
                .then(({ url }) => {
                  const anchor = document.createElement('a');
                  anchor.href = url.toString();
                  anchor.download = filename;
                  anchor.dispatchEvent(new MouseEvent('click'));
                  return { status: 'COMPLETE', value: { url } };
                })
                .catch((error) => ({
                  status: 'FAILED',
                  message: error.message,
                  error,
                })),
            };
          },
        },
      },
    });
    return StorageBrowserComponent;
  }, []);

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 12,
        }}
      >
        <img
          src="https://getpowerpay.com/wp-content/uploads/2023/10/FullColorLogo-1.svg"
          alt="PowerPay"
          style={{ height: 32, width: 'auto' }}
        />
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>
          PowerPay S3 File Browser
        </h1>
        <button onClick={signOut} type="button">
          Sign out
        </button>
      </div>
      <StorageBrowser />
    </div>
  );
}

export default withAuthenticator(App, {
  hideSignUp: true,
});
